/* unplugin-vue-components disabled */import { render } from "./empty.vue?vue&type=template&id=85700a66&scoped=true"
import script from "./empty.vue?vue&type=script&setup=true&lang=js"
export * from "./empty.vue?vue&type=script&setup=true&lang=js"

import "./empty.vue?vue&type=style&index=0&id=85700a66&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85700a66"],['__file',"src/controls/empty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85700a66"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85700a66', __exports__)) {
    api.reload('85700a66', __exports__)
  }
  
  module.hot.accept("./empty.vue?vue&type=template&id=85700a66&scoped=true", () => {
    api.rerender('85700a66', render)
  })

}


export default __exports__